import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

/** Page banner: h1 title, one-line subtitle, actions on the right (they wrap under the title on narrow screens). */
export function PageHeader({ title, subtitle, actions }: { title: string; subtitle?: string; actions?: ReactNode }) {
    return (
        <Box
            component="header"
            sx={{
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                px: 3,
                py: 2,
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <Box sx={{ flexGrow: 1, minWidth: 200 }}>
                <Typography variant="h4" component="h1">
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {actions && <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>{actions}</Box>}
        </Box>
    );
}
